import React, { useContext } from 'react';
import { useDataModel } from '@thd-nucleus/data-sources';
import { Typography } from '@one-thd/sui-atomic-components';
import { ExperienceContext } from '@thd-nucleus/experience-context';

import { propTypesEmtQuestionsAndAnswers } from './constants';
import { emtContentDataModel } from '../dataModels';

const EmtQuestionsAndAnswersComponent = ({ nValue }) => {
  const ctx = useContext(ExperienceContext);
  const initialNValue = nValue || ctx?.customContext?.variables?.navParam;
  const finalNValue = initialNValue?.indexOf('N-') < 0 ? `N-${initialNValue}` : initialNValue;

  const { data, loading, error } = useDataModel('emtContent', {
    variables: {
      contentId: finalNValue,
      pageName: 'plp'
    },
    skip: !finalNValue
  });

  const questionsAndAnswers = data?.emtContent?.content?.questionAndAnswer?.Questions || [];

  const hasQuestionsAndAnswers = questionsAndAnswers.length > 1;

  if (error || loading || !hasQuestionsAndAnswers) return null;

  return (
    <div className="sui-flex sui-flex-col sui-gap-4" data-component="QuestionsAndAnswers">
      <Typography variant="h2" weight="display">Questions & Answers</Typography>
      <div className="sui-flex sui-flex-col sui-gap-3">
        {questionsAndAnswers.map((qa, index) => (
          <div key={index}>
            <Typography variant="body-base" weight="bold" dangerouslySetInnerHTML={{ __html: qa.Question }} />
            <Typography variant="body-base" dangerouslySetInnerHTML={{ __html: qa.Answer }} />
          </div>
        ))}
      </div>
    </div>
  );
};

EmtQuestionsAndAnswersComponent.propTypes = propTypesEmtQuestionsAndAnswers;

EmtQuestionsAndAnswersComponent.displayName = 'EmtQuestionsAndAnswers';

EmtQuestionsAndAnswersComponent.dataModel = emtContentDataModel;

export { EmtQuestionsAndAnswersComponent };